import './fonts.css';
import './App.css';
import Main from './components/Main/Main';

import { withAuthenticator } from '@aws-amplify/ui-react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import { Amplify, API } from 'aws-amplify';
import awsconfig from './aws-exports';
import store from './store'
import { Provider } from 'react-redux'

Amplify.configure(awsconfig);

function App() {

  return (
    <Authenticator loginMechanisms={['email']}>
      {({ signOut, user }) => (<div className="App">
        <Provider store = {store}>
          <Main/>
        </Provider>
      </div>)}
    </Authenticator>
    
  );
}

export default withAuthenticator(App);